export default { "backEndUrl": 'https://afdev.dblandit.io/' }